/*
 * Dynamic product-card pricing (RRP / Member / Clearance).
 *
 * Recomputes the three price lines when a colour swatch is selected on a product
 * card (collection grid + predictive/search). Colour selection is driven by the
 * Globo Color Swatch app; this script only reads the chosen colour and re-renders.
 *
 * "From" rules (per Member and Clearance line, only when scope > 1 variant):
 *   - show "From {min}" when values differ across scope OR only some variants
 *     qualify (member present / on clearance) for that line.
 *
 * Money is never formatted in JS: each variant carries a pre-formatted string and
 * we display the formatted string of the minimum-cents variant in scope.
 */
(function () {
  function parseData(block) {
    var script = block.querySelector('.card-price-dynamic-data');
    if (!script) return null;
    try {
      return JSON.parse(script.textContent);
    } catch (e) {
      return null;
    }
  }

  function minBy(list, key) {
    var min = null;
    for (var i = 0; i < list.length; i++) {
      var val = list[i][key];
      if (val == null) continue;
      if (min === null || val < min) min = val;
    }
    return min;
  }

  function maxBy(list, key) {
    var max = null;
    for (var i = 0; i < list.length; i++) {
      var val = list[i][key];
      if (val == null) continue;
      if (max === null || val > max) max = val;
    }
    return max;
  }

  function firstWith(list, key, value) {
    for (var i = 0; i < list.length; i++) {
      if (list[i][key] === value) return list[i];
    }
    return null;
  }

  function representative(scope) {
    for (var i = 0; i < scope.length; i++) {
      if (scope[i].available) return scope[i];
    }
    return scope[0];
  }

  function setLine(block, role, fromVisible, moneyStr) {
    var fromEl = block.querySelector('[data-price-role="' + role + '-from"]');
    var amountEl = block.querySelector('[data-price-role="' + role + '-amount"]');
    if (fromEl) fromEl.hidden = !fromVisible;
    if (amountEl) amountEl.textContent = moneyStr;
  }

  function recompute(block, colour) {
    var variants = block._cpdVariants;
    if (!variants || !variants.length) return;

    var scope = variants.slice();
    if (colour) {
      var lc = String(colour).toLowerCase();
      var filtered = variants.filter(function (v) {
        return String(v.color || '').toLowerCase() === lc;
      });
      if (filtered.length) scope = filtered;
    }

    var total = scope.length;
    var rep = representative(scope);

    // 1. RRP — current/representative variant only, never "From".
    var rrpEl = block.querySelector('[data-price-role="rrp"]');
    if (rrpEl && rep) rrpEl.textContent = rep.moneyRrp;

    // 2. Member
    var memItem = block.querySelector('[data-price-role="member-item"]');
    if (memItem) {
      var withMember = scope.filter(function (v) {
        return v.member != null;
      });
      if (!withMember.length) {
        memItem.hidden = true;
      } else {
        var minM = minBy(withMember, 'member');
        var maxM = maxBy(withMember, 'member');
        var showFrom = total > 1 && (minM !== maxM || withMember.length < total);
        var minVar = firstWith(withMember, 'member', minM);
        setLine(block, 'member', showFrom, minVar ? minVar.moneyMember : '');
        var struck = !!(rep && rep.onClearance);
        memItem.classList.toggle('member-price__item--struck', struck);
        memItem.hidden = false;
      }
    }

    // 3. Clearance
    var clItem = block.querySelector('[data-price-role="clearance-item"]');
    if (clItem) {
      var onClear = scope.filter(function (v) {
        return v.onClearance;
      });
      if (!onClear.length) {
        clItem.hidden = true;
      } else {
        var minC = minBy(onClear, 'clearance');
        var maxC = maxBy(onClear, 'clearance');
        var showFromC = total > 1 && (minC !== maxC || onClear.length < total);
        var minVarC = firstWith(onClear, 'clearance', minC);
        setLine(block, 'clearance', showFromC, minVarC ? minVarC.moneyClearance : '');
        clItem.hidden = false;
      }
    }
  }

  function initBlock(block) {
    if (block._cpdInit) return;
    var data = parseData(block);
    if (!data) return;
    block._cpdVariants = data;
    block._cpdInit = true;
    // Initial state already server-rendered for scope=all; no recompute needed.
  }

  function initAll(root) {
    (root || document).querySelectorAll('.card-price-dynamic').forEach(initBlock);
  }

  // Map a clicked swatch to its product id + selected colour.
  function readSwatchSelection(target) {
    if (!target || !target.closest) return null;

    // Globo renders swatches inside [globo-product-swatch-id] / [product-swatch-id].
    var container = target.closest(
      '[globo-product-swatch-id], [product-swatch-id], .swatches-globo, .globo-swatch-product-item'
    );
    if (!container) return null;

    var productId =
      container.getAttribute('globo-product-swatch-id') ||
      container.getAttribute('product-swatch-id') ||
      container.getAttribute('product-selector');

    if (!productId) {
      var withId = target.closest('[product-swatch-id], [globo-product-swatch-id], [product-selector]');
      if (withId) {
        productId =
          withId.getAttribute('product-swatch-id') ||
          withId.getAttribute('globo-product-swatch-id') ||
          withId.getAttribute('product-selector');
      }
    }
    if (!productId) return null;

    // Colour from the clicked swatch option.
    var colour = '';
    var li = target.closest('li[productid], li.swatches-options');
    if (li) {
      var input = li.querySelector('input');
      if (input && input.value) colour = input.value;
      if (!colour) {
        var hover = li.querySelector('.attr-title-hover');
        if (hover) colour = hover.textContent.trim();
      }
    }
    if (!colour) {
      var lbl = target.closest('label');
      if (lbl) {
        var forId = lbl.getAttribute('for');
        if (forId) {
          var inp = document.getElementById(forId);
          if (inp && inp.value) colour = inp.value;
        }
      }
    }
    if (!colour) return null;

    return { productId: String(productId), colour: colour };
  }

  function findBlockForProduct(productId) {
    return document.querySelector('.card-price-dynamic[data-product-id="' + productId + '"]');
  }

  // Recompute is locked during the page/Globo init window so the initial collection-page
  // render keeps the server-rendered scope=ALL state (the "From" logic), even though Globo
  // pre-selects the first colour on load. Only genuine user selections AFTER settle recompute.
  var interactionReady = false;
  function enableInteraction() {
    interactionReady = true;
  }

  function handleSelection(target) {
    if (!interactionReady) return;
    var sel = readSwatchSelection(target);
    if (!sel) return;
    var block = findBlockForProduct(sel.productId);
    if (!block) return;
    initBlock(block);
    recompute(block, sel.colour);
  }

  // IMPORTANT: only react to GENUINE user interaction. Globo pre-selects the first colour
  // on load (programmatically), which fires synthetic click/change events (isTrusted === false).
  // Ignoring those keeps the initial render at scope = ALL variants (so the "From" logic shows
  // on load); we only narrow to a colour when the shopper actually clicks a swatch.
  document.addEventListener(
    'click',
    function (e) {
      if (!e.isTrusted) return;
      handleSelection(e.target);
    },
    true
  );

  document.addEventListener(
    'change',
    function (e) {
      if (!e.isTrusted || !interactionReady) return;
      var t = e.target;
      // Globo hidden variant <select name="idGlobo"> carries data-option1 (colour).
      if (t && t.tagName === 'SELECT' && /idGlobo|globo-selector/i.test(t.name + ' ' + t.className)) {
        var opt = t.options[t.selectedIndex];
        var colour = opt && opt.getAttribute('data-option1');
        var container = t.closest('[globo-product-swatch-id], [product-swatch-id]');
        var productId = container
          ? container.getAttribute('globo-product-swatch-id') || container.getAttribute('product-swatch-id')
          : null;
        if (colour && productId) {
          var block = findBlockForProduct(String(productId));
          if (block) {
            initBlock(block);
            recompute(block, colour);
          }
        }
        return;
      }
      handleSelection(t);
    },
    true
  );

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll();
    });
  } else {
    initAll();
  }

  // Unlock user-driven recompute only after load + a short settle window, so Globo's
  // on-load pre-selection (which can fire events during init) never collapses the
  // initial all-variants "From" render. Genuine clicks happen well after this.
  function scheduleInteractionUnlock() {
    setTimeout(enableInteraction, 1200);
  }
  if (document.readyState === 'complete') {
    scheduleInteractionUnlock();
  } else {
    window.addEventListener('load', scheduleInteractionUnlock);
  }

  // Globo injects swatches asynchronously; keep blocks registered as cards appear.
  if (typeof MutationObserver !== 'undefined') {
    var grid =
      document.getElementById('product-grid') ||
      document.querySelector('.product-grid') ||
      document.body;
    if (grid) {
      var obs = new MutationObserver(function (mutations) {
        for (var i = 0; i < mutations.length; i++) {
          var added = mutations[i].addedNodes;
          for (var j = 0; j < added.length; j++) {
            var node = added[j];
            if (node.nodeType !== 1) continue;
            if (node.classList && node.classList.contains('card-price-dynamic')) {
              initBlock(node);
            } else if (node.querySelectorAll) {
              initAll(node);
            }
          }
        }
      });
      obs.observe(grid, { childList: true, subtree: true });
    }
  }
})();
